export const fData = [
  {
    id: 'qa1a1',
    ques: 'What type of payment do you accept?',
    ans: 'We accept the following payment methods: Payoneer, SWIFT, Visa, Mastercard',
  },
  {
    id: 'qa1a2',
    ques: 'Can I pay after I get the results?',
    ans: "No, but you can pay half of the project's estimated cost and send the payment with the second half after you approve the results.",
  },
  {
    id: 'qa1a3',
    ques: 'What is your turnaround time?',
    ans: 'The standard turnaround time for an architectural rendering project is 1 week and for an interior design rendering project is 4 days. The exact TAT, however, depends on many factors – the number of views, complexity, details, etc. Please send us a brief about your project along with documents and your requirements. We will check all the requirements and give you TAT info.',
  },
  {
    id: 'qa1a4',
    ques: 'What are your working hours?',
    ans: 'Our online support works 9 AM to 9 PM Kyiv time (GMT+3). You can call, email or leave a message for us at any time.',
  },
  {
    id: 'qa1qa5',
    ques: 'Can you handle multiple projects together?',
    ans: "As many as you need! The sky's the limit. We always have teams to take up the project of any scale, and they can work on your tasks simultaneously.",
  },
  {
    id: 'qa1a6',
    ques: 'What files do I need to send to start a project?',
    ans: 'Generally, you can send us any kind of files, either hand sketches or even a video briefing. The most basic references are drawings, architectural or design sketches, and mood boards. If you have the exact idea for a project, you can send us everything you have. Ideally, we prefer to work with the following formats of files: - for plans and drawings – CAD format, pdf or any other vector format; - for ready 3D models – stl, 3ds, max, obj.',
  },
  {
    id: 'qa1a7',
    ques: 'How long does it take?',
    ans: 'The time it takes to complete a project, depends on the scope of work and the complexity of a project. To determine the turnaround time for your project, please send us a brief description of your project along with any documents and requirements you have. We will calculate the TAT and inform you.',
  },
 
  {
    id: 'qa1qa8',
    ques: 'How much do 3D rendering services cost?',
    ans: "The time it takes to complete an order for this service depends on the scope of work and the complexity of a project. To learn the exact TAT for your project, please send us a brief, we will calculate the turnaround time for your order based on your requirements.",
  },
  {
    id: 'qa1qa9',
    ques: 'How much does it cost?',
    ans: 'For an exact price estimate, please send us a brief description of your project, along with any documents and requirements. You will get a quote within 1 day.',
  },

  {
    id: 'qa1a10',
    ques: 'How do you guarantee the quality?',
    ans: 'We use a thorough double quality control system. It consists of two levels — first, project managers check results. Next, mentors evaluate the work once again for compliance with aesthetic quality standards of the studio.',
  },

]

export const mFData =[
  
  {
    id: 'qa1a1',
    ques: 'What type of payment do you accept?',
    ans: 'We accept the following payment methods: Payoneer, SWIFT, Visa, Mastercard',
  },
  {
    id: 'qa1a2',
    ques: 'Can I pay after I get the results?',
    ans: "No, but you can pay half of the project's estimated cost and send the payment with the second half after you approve the results.",
  },
  {
    id: 'qa1a3',
    ques: 'What is your turnaround time?',
    ans: 'The standard turnaround time for an architectural rendering project is 1 week and for an interior design rendering project is 4 days. The exact TAT, however, depends on many factors – the number of views, complexity, details, etc. Please send us a brief about your project along with documents and your requirements. We will check all the requirements and give you TAT info.',
  },
  {
    id: 'qa1a4',
    ques: 'What are your working hours?',
    ans: 'Our online support works 9 AM to 9 PM Kyiv time (GMT+3). You can call, email or leave a message for us at any time.',
  },
  {
    id: 'qa1qa5',
    ques: 'Can you handle multiple projects together?',
    ans: "As many as you need! The sky's the limit. We always have teams to take up the project of any scale, and they can work on your tasks simultaneously.",
  },
  {
    id: 'qa1a6',
    ques: 'What files do I need to send to start a project?',
    ans: 'Generally, you can send us any kind of files, either hand sketches or even a video briefing. The most basic references are drawings, architectural or design sketches, and mood boards. If you have the exact idea for a project, you can send us everything you have. Ideally, we prefer to work with the following formats of files: - for plans and drawings – CAD format, pdf or any other vector format; - for ready 3D models – stl, 3ds, max, obj.',
  },
  {
    id: 'qa1a7',
    ques: 'How long does it take?',
    ans: 'The time it takes to complete a project, depends on the scope of work and the complexity of a project. To determine the turnaround time for your project, please send us a brief description of your project along with any documents and requirements you have. We will calculate the TAT and inform you.',
  },
 
  {
    id: 'qa1qa8',
    ques: 'How much do 3D rendering services cost?',
    ans: "The time it takes to complete an order for this service depends on the scope of work and the complexity of a project. To learn the exact TAT for your project, please send us a brief, we will calculate the turnaround time for your order based on your requirements.",
  },
  {
    id: 'qa1qa9',
    ques: 'How much does it cost?',
    ans: 'For an exact price estimate, please send us a brief description of your project, along with any documents and requirements. You will get a quote within 1 day.',
  },

  {
    id: 'qa1a10',
    ques: 'How do you guarantee the quality?',
    ans: 'We use a thorough double quality control system. It consists of two levels — first, project managers check results. Next, mentors evaluate the work once again for compliance with aesthetic quality standards of the studio.',
  },
]

export const fSecond = [
  {
    ques: '3D rendering',
    ans: 'The process of generation of a photorealistic or non-photorealistic image with 3D models using 3D rendering software. The resulting product is called a 3D render.',
    id: 'q02t1a1'
  },
  {
    ques: 'Interior rendering',
    ans: 'The process of generation of a photorealistic or non-photorealistic image with 3D models using 3D rendering software. The resulting product is called a 3D render.',
    id: 'q02t2a2'
  },
  {
    ques: 'Exterior rendering',
    ans: 'The process of generation of a photorealistic or non-photorealistic image with 3D models using 3D rendering software. The resulting product is called a 3D render.',
    id: 'q02t3a3'
  },
  {
    ques: '3D modeling',
    ans: 'The process of creation of a representation of an object in three dimensions using 3D modeling software. The resulting product is called a 3D model.',
    id: 'q02t4a4'
  },
  {
    ques: '3D animation',
    ans: 'The process of generating three-dimensional videos in a digital environment. To create a 3D animation, 3D artists carefully manipulate 3D objects within 3D software for exporting sequences of still images. These CG pictures are then used together to create the illusion of movement in a 3D animation.',
    id: 'q02t5a5'
  },
  {
    ques: '360° virtual tour',
    ans: 'A collection of 360-degree panoramic rotating images, composed together to form a full, 360° view of a location.',
    id: 'q02t6a6'
  },
  {
    ques: 'Post-production',
    ans: 'Compositing a photo into a CGI scene or retouching a 3D render to achieve maximum realism. It usually consists of adding visual effects and contextual elements such as cars and people.',
    id: 'q02t7a7'
  },
  {
    ques: 'VR tour',
    ans: 'An artificial environment providing an interactive immersive experience through the simulation of sensory events, such as sight and sound. Objects are recreated digitally and placed in a virtual environment for the user to experience them like in real life — interact with them, see their features and benefits, change options, etc.',
    id: 'q02t8a8'
  },
  {
    ques: 'Floor plan',
    ans: 'A drawing to scale, showing a view from above, of the relationships between rooms, spaces, traffic patterns, and other physical features at one level of a structure.',
    id: 'q02t9a9'
  },
  {
    ques: 'Draft visualization',
    ans: 'With draft visualization, we can show you how a project looks before the final rendering. The quality of lighting, reflections, glossiness, and object materials in drafts are strongly reduced to save time and computer resources. Draft visualizations allow you to check the whole composition and every small detail of the project to make necessary corrections before the final rendering.',
    id: 'q02t10a1'
  }
]
